// 4.12 Mobile premium: the light motions that replace the desktop pointer effects on phones and touch screens.
// Scroll reveals of the cards and the orange card light under the finger. Without JS the page is the same, just still.
(() => {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  // meucompra-vitrine.js already reveals on a desktop with a mouse; this covers everything else
  if (reduce || (fine && innerWidth >= 900)) return;

  // Scroll reveals: content is visible at rest; cards below the fold start 24 px lower and rise when seen.
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.remove('mb-pre'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.pr-cat, .vt-spot, .product-card, .pr-trust a').forEach((el, i) => {
      if (el.getBoundingClientRect().top < innerHeight) return;
      el.classList.add('mb-reveal', 'mb-pre'); el.style.transitionDelay = `${(i % 2) * 50}ms`; io.observe(el);
    });
  }

  // Touch light: the card's orange spotlight lights up where the finger lands and fades after the tap.
  document.addEventListener('pointerdown', e => {
    if (e.pointerType === 'mouse') return;
    const el = e.target.closest && e.target.closest('.product-card .product-media, .pr-cat');
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${e.clientX - r.left}px`); el.style.setProperty('--my', `${e.clientY - r.top}px`);
    el.classList.add('mb-lit');
    clearTimeout(el.mbTimer); el.mbTimer = setTimeout(() => el.classList.remove('mb-lit'), 700);
  }, { passive: true });
})();
